module.exports = __webpack_public_path__ + "img/5b1d58f3ed40fe4be6acb8fb45e89f1d.f07199f4.jpg";